// src/hooks/useApi.js
import { useState, useEffect } from 'react';
import {
  getTransactionsByAccount,
  getAccountBalance,
  getExpensesByCategory,
} from '../services/api';

export const useTransactions = (account) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getTransactionsByAccount(account);
        setData(response.data);
      } catch (error) {
        console.error("Erreur lors de la récupération des transactions:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [account]);

  return { data, loading };
};

export const useBalance = (account) => {
  const [balance, setBalance] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBalance = async () => {
      try {
        const response = await getAccountBalance(account);
        setBalance(response.data.balance);
      } catch (error) {
        console.error("Erreur lors de la récupération du solde:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchBalance();
  }, [account]);

  return { balance, loading };
};

export const useExpensesByCategory = (account) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getExpensesByCategory(account);
        setData(response.data);
      } catch (error) {
        console.error("Erreur lors de la récupération des dépenses par catégorie:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [account]);

  return { data, loading };
};
